
import { permission } from 'App/permission/permission';

const Cookie = {
	init: function () {
		permission.get({
			type: 'cookie'
		});
	}
};

export { Cookie };
